'use strict';

if (!window.setRecaptchaToken) {
  window.setRecaptchaToken = function (token) {
    document.querySelector('input[name=googleRecaptchaToken]').value = token;
  }
}

if (!window.onRecaptchaExpired) {
  window.onRecaptchaExpired = function () {
    const tokenInput = document.querySelector('input[name=googleRecaptchaToken]');
    if (tokenInput) {
      tokenInput.value = '';
      window.grecaptcha.reset();
    }
  }
}
